import { request } from "../../../Services/Api"

export const getApiKeysList = (params = { page: 1, page_size: 100 }) => {
  return request.api.get("/restful_api/public_api/settings/api-keys", params)
}

export const generateApiKey = (params) => {
  return request.api.post("/public/v1/api-keys/", params)
}

export const regenerateApiKey = (params) => {
  return request.api.patch("/public/v1/api-keys/regenerate/", params)
}

export const getPublicApiSettings = () => {
  return request.api.get("/restful_api/public_api/settings")
}

//endpoints
export const getEndpoints = (params) => {
  return request.api.get("/restful_api/webhooks/endpoints", params)
}

export const getEndpoint = ({ endpoint_id, ...params }) =>
  request.api.get(`/restful_api/webhooks/endpoints/${endpoint_id}`, params)

export const changeEndpointStatus = ({ endpoint_id, ...params }) => {
  return request.api.post(`/restful_api/webhooks/endpoints/${endpoint_id}/status`, params)
}

export const deleteEndpoint = ({ endpoint_id }) => {
  return request.api.delete(`/restful_api/webhooks/endpoints/${endpoint_id}`)
}

export const addTypes = (params) => {
  return request.api.post("/restful_api/webhooks/endpoints", params)
}

export const addEndpoint = (params) => {
  return request.api.post("/restful_api/webhooks/endpoints", params)
}

//events
export const getEvents = (params) => {
  return request.api.get("/restful_api/webhooks/events", params)
}
export const getEvent = ({ event_id, ...params }) => {
  return request.api.get(`/restful_api/webhooks/events/${event_id}`, params)
}

export const resendEvent = ({ endpoint_id, log_id }) => {
  return request.api.post(`/restful_api/webhooks/endpoints/${endpoint_id}/events/${log_id}/resend`)
}
